<template>
  <section class="faq">
    <div class="wrap">
      <h2 class="title">
        ¿Necesitas más ayuda?<br />
        <span>Consulta las preguntas frecuentes.</span>
      </h2>
      <div class="list">
        <div
          v-for="(item, i) in faqs"
          :key="i"
          class="item"
        >
          <button class="q" type="button" @click="toggle(i)">
            <span class="q-text">{{ item.q }}</span>
            <span class="icon" :class="{ open: openIndex === i }" aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 24 24">
                <path d="M6 15l6-6 6 6" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
          </button>
          <div v-show="openIndex === i" class="a">
            <div v-if="Array.isArray(item.a)">
              <p v-for="(p, idx) in item.a" :key="idx" class="p">{{ p }}</p>
            </div>
            <div v-else>
              <p class="p">{{ item.a }}</p>
            </div>
            <ol v-if="item.steps?.length" class="steps">
              <li v-for="(s, idx) in item.steps" :key="idx">{{ s }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'

const openIndex = ref(0)

const faqs = ref([
  {
    q: '¿Por qué cambiarán de App?',
    a: 'Porque estamos mejorando nuestra plataforma para ofrecerte un experiencia más ágil, moderna y segura.'
  },
  {
    q: '¿Perderé mi información?',
    a: 'No, todos tus datos, historial y beneficios serán migrados automáticamente a la App de Banco Azteca.'
  },
  {
    q: '¿Qué necesito hacer?',
    a: 'Solo descarga la App de "Banco Azteca" e inicia sesión con tus mismos datos:',
    steps: [
       'I. Descarga la App en google play o app store.',
       'II. Ingresa con tu mismo usuario, celular o correo.',
       'III. Confirma tu información y listo.'
    ]
  },
  {
    q: '¿Hasta cuándo puedo usar la App actual?',
    a: 'Hasta el 15 de abril de 2026. Después de esta fecha, la app dejará de funcionar.'
  },
  {
    q: '¿Dónde puedo pedir ayuda si tengo dudas?',
    a: [
      'En nuestro chat de soporte dentro de la App de Banco Azteca',
      'Contacto',
      'Correo: atencionaclientesbienestarazteca@bancoazteca.com',
      'Teléfono 55 7600 6440'
    ]
  }
])

function toggle(i) {
  openIndex.value = openIndex.value === i ? -1 : i
}
</script>

<style scoped>
.faq{
  background:#fff;
  padding: 70px 16px 60px;
}

.wrap{
  max-width: 980px;
  margin: 0 auto;
}

.title{
  text-align:center;
  font-size: 42px;
  font-weight: 900;
  margin: 0 0 38px;
  line-height: 1.1;
  color:#2b2b2b;
}

.title span{
  color:#17A54D;
}

.list{
  border-top: 1px solid #e6e6e6;
}

.item{
  border-bottom: 1px solid #e6e6e6;
  padding: 14px 0;
}

.q{
  width:100%;
  background:transparent;
  border:0;
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding: 14px 0;
  cursor:pointer;
  text-align:left;
}

.q-text{
  font-size: 18px;
  font-weight: 800;
  color:#2b2b2b;
}

.icon{
  color:#17A54D;
  transition: transform .15s ease;
}

.icon.open{
  transform: rotate(180deg);
}

.a{
  padding: 10px 0 16px;
  text-align: left;
}

.p{
  margin: 0px 0 12;
  color:#777;
  line-height: 1.6;
  font-size: 16px;
   text-align: left;
}

.steps{
  list-style: none;
  margin: 15px 0 0 40px;
  padding: 0;
  color:#777;
  line-height: 1.8;
  font-size: 16px;
}

.steps li {
  text-align: left;
  margin-bottom: 4px;
}

@media (max-width: 768px){
  .title{
    font-size: 30px;
  }
  .q-text{
    font-size: 16px;
  }
  .p, .steps{
    font-size: 15px;
  }
}
</style>
